// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3381":"92bffc35","6656":"57af67d7","8758":"ab98e392","9304":"63d8173b"}[chunkId] + ".chunk.css";
};